import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'src/app/shared/reports.service';
declare let gtag;
declare var $:any;
@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {

  resetMessage = "";
  success_sent: boolean = false;
  enquiry_header = 'Enquiry';
  request_demo_info = {
    form_type: 'demo',
    name: null,
    email: null,
    organization:null,
    phone: null,
    location: null,
    message: ""
  };

  required_display_counter: number = 0;
  isRequestDemoSaving = false;

  locations = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttarakhand',
    'Uttar Pradesh',
    'West Bengal',
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'Delhi NCR',
    'Lakshadweep',
    'Puducherry'
  ]
  constructor(    private router: Router,
    private route: ActivatedRoute,
    private reportsService: ReportsService,
    
    ) {

     }

  ngOnInit() {
    if (this.router.url == '/demo') {
      $('#free-demo').modal('show');
      $('#enquiry-header').text('Demo Request');
    }
  }

  async submitRequest() {
    let fresh_data = {
      first_name: this.request_demo_info.name.substr(0, this.request_demo_info.name.indexOf(' ')),
      last_name: this.request_demo_info.name.substr(this.request_demo_info.name.indexOf(' ') + 1),
      email: this.request_demo_info.email,
      mobile_number: this.request_demo_info.phone,
      address: this.request_demo_info.location,
      organization:this.request_demo_info.organization,
      created_at: new Date().toISOString(),
    }

    try {
      console.log('clicked');
      this.isRequestDemoSaving  = true;
      let response = await this.reportsService.contactForDemo(this.request_demo_info).toPromise();
      if (response['code'] = '200') {
        // console.log(response);
        this.success_sent = true;
        this.request_demo_info = {
          form_type: 'demo',
          name: null,
          email: null,
          phone: null,
          organization:null,
          location: null,
          message: ""
        };
        this.gtag_report_conversion(this.router.url);
      }
    } catch (E) {
      console.log(E);
    } finally {
      this.isRequestDemoSaving = false;
    }
  }

  clearDemo(form: NgForm) {
    this.request_demo_info = {
      form_type: 'demo',
      name: null,
      email: null,
      phone: null,
      organization:null,
      location: null,
      message: ""
    };
    this.success_sent = false;
    form.reset();
  }

  isInvalid() {
    if (!this.request_demo_info.name || !this.request_demo_info.phone || !this.request_demo_info.email || !this.request_demo_info.location) {
      return true;
    }
  }

  gtag_report_conversion(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', {
        'send_to': 'AW-11079307091/t4dCCPjujI0YENOeg6Mp',
        'value': 1.0,
        'currency': 'INR',
        'event_callback': callback
    });
    return false;
  }
}
